var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "composer-menu-area" },
    [
      _c("menu-controls", {
        attrs: {
          showSaveButton: _vm.showSaveButton,
          showUnlockButton: _vm.showUnlockButton,
          showCloneButton: _vm.showCloneButton,
          isValidForm: _vm.isValidForm
        },
        on: {
          save: _vm.saveClick,
          unlock: _vm.unlockClick,
          clone: _vm.cloneClick
        }
      }),
      _vm._v(" "),
      _c("menu-brick-toolbox", {
        attrs: { journeyType: _vm.journeyType },
        on: {
          "add-brick": function($event) {
            return _vm.$emit("add-brick", $event)
          }
        }
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("menu-checkpoint-toolbox"),
      _vm._v(" "),
      _c("menu-journey-filters"),
      _vm._v(" "),
      _c("menu-edit-form", {
        ref: "editForm",
        attrs: {
          "journey-name": _vm.journeyName,
          "journey-world": _vm.journeyWorld,
          "journey-description": _vm.journeyDescription,
          "journey-start-date": _vm.journeyStartDate,
          "journey-end-date": _vm.journeyEndDate,
          "journey-is-active": _vm.journeyIsActive,
          "journey-division-id": _vm.journeyDivisionId,
          "journey-type": _vm.journeyType
        },
        on: {
          "update:journeyName": function($event) {
            return _vm.$emit("update:journeyName", $event)
          },
          "update:journeyWorld": function($event) {
            return _vm.$emit("update:journeyWorld", $event)
          },
          "update:journeyDescription": function($event) {
            return _vm.$emit("update:journeyDescription", $event)
          },
          "update:journeyStartDate": function($event) {
            return _vm.$emit("update:journeyStartDate", $event)
          },
          "update:journeyEndDate": function($event) {
            return _vm.$emit("update:journeyEndDate", $event)
          },
          "update:journeyIsActive": function($event) {
            return _vm.$emit("update:journeyIsActive", $event)
          },
          "update:journeyDivisionId": function($event) {
            return _vm.$emit("update:journeyDivisionId", $event)
          },
          "update:journeyType": function($event) {
            return _vm.$emit("update:journeyType", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("menu-controls", {
        attrs: {
          showSaveButton: _vm.showSaveButton,
          showUnlockButton: _vm.showUnlockButton,
          showCloneButton: _vm.showCloneButton,
          isValidForm: _vm.isValidForm
        },
        on: {
          save: _vm.saveClick,
          unlock: _vm.unlockClick,
          clone: _vm.cloneClick
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("label", [_vm._v("Journey Composer bricks")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("label", [_vm._v("Connectie checkpoints")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }